import React, { Suspense } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { HelmetProvider } from "react-helmet-async";
import Layout from './hoc/Layout/Layout';
import LandingPage from './containers/LandingPage/LandingPage';
import NotFound from './components/UI/NotFound/NotFound';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab, faFacebook, faInstagram, faPinterest } from '@fortawesome/free-brands-svg-icons';
import { faThumbtack, faSeedling, faHandHoldingHeart, faAt, faHamburger, faCandyCane, faPuzzlePiece, faAngleUp, faAngleDown, faBook, faLayerGroup, faChild, faTree, faUserCircle, faMapMarkerAlt, faPhoneAlt, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import ScrollToTop from './components/UI/ScrollToTop';

const SladkoIliSolenoPage = React.lazy(() => import('./components/SEO/SladkoIliSolenoPage'));
const RecipeDetailPage = React.lazy(() => import('./components/RecipesPages/RecipeDetailPage/RecipeDetailPage'));
const Gardening = React.lazy(() => import('./components/Gardening/Gardening'));
const Recipes = React.lazy(() => import('./containers/Recipes/Recipes'));
const ContactForm = React.lazy(() => import('./containers/Footer/ContactForm/ContactForm'));
const About = React.lazy(() => import('./components/About/About'));
// const NotFound = React.lazy(() => import('./components/UI/NotFound/NotFound'));

function App() {
  library.add(faThumbtack, faSeedling, faHandHoldingHeart, faAt, faHamburger, faCandyCane, faPuzzlePiece, fab, faAngleUp, faAngleDown, faBook, faLayerGroup, faChild, faTree, faUserCircle, faFacebook, faInstagram, faPinterest, faMapMarkerAlt, faPhoneAlt, faEnvelope);

  return (
	<HelmetProvider>
	  <Layout>
		<Suspense fallback={<p>Loading...</p>}>
		 <ScrollToTop />
		  <Switch>
			<Route path="/" exact component={LandingPage} />
			<Route path="/recipes" exact component={LandingPage} />
			<Route path="/recipes/:recipeType" exact component={Recipes} />
			<Route path="/recipes/:recipeType/:slug" component={RecipeDetailPage} />
			<Route path="/sladko-ili-soleno" component={SladkoIliSolenoPage} />
			<Route path="/contactForm" component={ContactForm} />
			<Route path="/gardening" component={Gardening} />
			<Route path="/about" component={About} />
			{/* I should create NotFound.js;
			the '*' means: any path(url) should match this path!!!!!*/}
			<Route path="*" component={NotFound} />
			<Redirect to="/" />
		  </Switch>
		</Suspense>
	  </Layout>
	</HelmetProvider>
  );
}

export default App;